export default {
    totals: 'Totais',
    grand_total: 'Total Geral',
    work_type: 'Atividades',
    quantity: 'Quantidade',
    total_time: 'Tempo Total',
    call: {
        category: 'Categoria',
        total_ticket: 'Total de Chamados',
        total_worklload: 'Total de Cargas de Trabalho',
    },
}
